// src/App.js
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import IndustryServices from './components/IndustryServices';
import OnSiteSupport from './components/OnSiteSupport';
import LeadershipTeam from './components/LeadershipTeam';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div>
      <Navbar />
      <main id="main">
        <section id="home"><Hero /></section>
        <section id="services"><Services /></section>
        <section id="industryservices"><IndustryServices /></section>
        <section id="onsitesupport"><OnSiteSupport /></section>
        <section id="leadershipteam"><LeadershipTeam /></section>
        <section id="contactform"><ContactForm /></section>
        <Footer />
      </main>
    </div>
  );
}

export default App;
